import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedBuilderId:'',
    selectedPropertyUnitId: '',
};

const builderSlice = createSlice({
    name: "Builder",
    initialState,
    reducers: {
        setSelectedBuilderId: (state, action) => {
            state.selectedBuilderId = action.payload;
        },
        resetSelectedBuilderId: (state) => {
            state.selectedBuilderId = '';
        },
        setSelectedPropertyUnitId: (state, action) => {
            state.selectedPropertyUnitId = action.payload;
        },
        resetSelectedPropertyUnitId: (state) => {
            state.selectedPropertyUnitId = '';
        },
    },
});

export const { setSelectedBuilderId, resetSelectedBuilderId, setSelectedPropertyUnitId, resetSelectedPropertyUnitId } = builderSlice.actions;

export default builderSlice.reducer;
